export default __webpack_public_path__ + "static/history-page-city-background-c19b3dce28dda1d6c31d431dbc18376f.jpg";